import axios from "axios";
import customConfig from "../config";
const ResponseInterceptor = () => {
  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      // Allow axios cancellation errors to propagate so callers can handle them correctly
      if (axios.isCancel && axios.isCancel(error)) {
        return Promise.reject(error);
      }
      if (
        error.response &&
        401 === error.response.status &&
        window.location.pathname !== "/"
      ) {
        alert(customConfig.sessionExpireMsg);
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("authInfo");
        localStorage.removeItem("userRoles");
        localStorage.removeItem("userLevel");
        localStorage.removeItem("loggedInUserName");
        window.location = "/";
      }

      // Updated due to axios version upgrade
      // IMPORTANT: reject so axios knows the request failed
      return Promise.reject(error);
    }
  );
};

export default ResponseInterceptor;
